import { useRef } from 'react';
import { VariableSizeList } from 'react-window';

import { useBreakpoint } from '@/hooks/useBreakpoint';

import {
    ListItemType,
    SecretListId,
    SecurityAuditGroupSize,
    SecurityAuditSecretWithAdditionalSize,
    SecurityAuditSecretWithAgeAndIndicatorSize,
} from '../../constants';
import { useSecretsListOffset } from '../../hooks/useSecretsListOffset';
import type { ListItemSize, SecurityAuditAgeItem } from '../../types';
import { SecurityAuditAgeItemRenderer } from '../SecurityAuditAgeItemRenderer';

export interface SecurityAuditAgeSecretsListProps {
    data: SecurityAuditAgeItem[];
    height: number;
    width: number;
}

export const SecurityAuditAgeSecretsList = ({ data, height, width }: SecurityAuditAgeSecretsListProps) => {
    const listRef = useRef<VariableSizeList<typeof data>>(null);

    const handleOffset = useSecretsListOffset(SecretListId.AUDIT_AGE_LIST, listRef);

    const isMin768 = useBreakpoint('sm');

    return (
        <VariableSizeList<typeof data>
            ref={listRef}
            height={height}
            width={width}
            itemData={data}
            itemCount={data.length}
            estimatedItemSize={isMin768 ? SecurityAuditSecretWithAdditionalSize.desktop : SecurityAuditSecretWithAdditionalSize.mobile}
            itemSize={index => {
                const item = data[index];

                let size: ListItemSize = SecurityAuditGroupSize;

                if (item.listItemType === ListItemType.SECRET) {
                    size = item.ignoreSecurityReport ? SecurityAuditSecretWithAgeAndIndicatorSize : SecurityAuditSecretWithAdditionalSize;
                }

                return isMin768 ? size.desktop : size.mobile;
            }}
            itemKey={index => data[index].key}
            onScroll={({ scrollOffset }) => {
                handleOffset(scrollOffset);
            }}
        >
            {/* @ts-expect-error */}
            {SecurityAuditAgeItemRenderer}
        </VariableSizeList>
    );
};
